import { render, staticRenderFns } from "./Manifesto.vue?vue&type=template&id=76b71a04&"
import script from "./Manifesto.vue?vue&type=script&lang=js&"
export * from "./Manifesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports